import { Directive, inject, Input, OnInit } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { MIN_MAT_SELECT_OVERLAY_WIDTH } from './mat-select-min-width.directive';

@Directive({
  selector: '[appMatSelectPanel]',
  standalone: false,
})
export class MatSelectPanelDirective implements OnInit {
  public readonly matSelect = inject(MatSelect);
  private readonly originalGetOverlayWidth = (this.matSelect as any)._getOverlayWidth?.bind(this.matSelect);
  private readonly overlapTriggerPositions = [
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top',
    },
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'bottom',
      panelClass: 'mat-mdc-select-panel-above',
    },
  ];

  // eslint-disable-next-line
  @Input('appMatPanelWidthValue') appMatPanelWidthValue: number | null = null;
  // eslint-disable-next-line
  @Input('appMatOverlapTrigger') appMatOverlapTrigger = false;

  ngOnInit(): void {
    if (this.originalGetOverlayWidth) {
      (this.matSelect as any)._getOverlayWidth = () => {
        const panelWidth = Number(this.appMatPanelWidthValue);

        if (!Number.isNaN(panelWidth) && panelWidth > 0) {
          if (typeof window !== 'undefined') {
            return Math.max(Math.min(panelWidth, window.innerWidth - 32), MIN_MAT_SELECT_OVERLAY_WIDTH);
          }

          return Math.max(panelWidth, MIN_MAT_SELECT_OVERLAY_WIDTH);
        }

        return this.originalGetOverlayWidth();
      };
    }

    if (this.appMatOverlapTrigger) {
      (this.matSelect as any)._positions = this.overlapTriggerPositions;
    }
  }
}
